import { Injectable, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { LocalStorage, LocalStorageService } from 'ngx-store';

import { Menu } from './menu.model';
import { ComponentsSettingsService } from '../../../services/components_settings.service';

// import { tms_components } from './menu';
// import { verticalMenuItems } from './menu';
// import { horizontalMenuItems } from './menu';


@Injectable()
export class MenuService {
  
  constructor(private location:Location, 
              private renderer2:Renderer2,
              private router:Router,
              private svc_component_settings: ComponentsSettingsService,
              public localStorageService: LocalStorageService){
                this.svc_component_settings.getLoginRole();
                this.getMenuItems();
              } 


  public getVerticalMenuItems():Array<Menu> {
    //var mi = new MenuItem();
    return this.vertical_menu_items;
  }

  public getHorizontalMenuItems():Array<Menu> {
    //var mi = new MenuItem();
    return this.horizontal_menu_items;
  }

  public createMenu(menu:Array<Menu>, nativeElement, type){    
     if(type=='vertical'){
       this.createVerticalMenu(menu, nativeElement);
     }
     if(type=='horizontal'){
       this.createHorizontalMenu(menu, nativeElement);
     }
  }

  public createVerticalMenu(menu:Array<Menu>, nativeElement){    
    let menu0 = this.renderer2.createElement('div');
    this.renderer2.setAttribute(menu0, 'id', 'menu0');
    menu.forEach((menuItem) => {
        if(menuItem.parentId == 0){
          let subMenu = this.createVerticalMenuItem(menu, menuItem);
          this.renderer2.appendChild(menu0, subMenu);
        }
    });
    this.renderer2.appendChild(nativeElement, menu0); 
  }

  public createHorizontalMenu(menu:Array<Menu>, nativeElement){
    let nav = this.renderer2.createElement('div');
    this.renderer2.setAttribute(nav, 'id', 'navigation');
    let ul = this.renderer2.createElement('ul');
    this.renderer2.addClass(ul, 'menu');
    this.renderer2.appendChild(nav, ul);
    menu.forEach((menuItem) => {
        if(menuItem.parentId == 0){
          let subMenu = this.createHorizontalMenuItem(menu, menuItem);
          this.renderer2.appendChild(ul, subMenu);
        }
    });
    this.renderer2.appendChild(nativeElement, nav); 
  }

  public createVerticalMenuItem(menu:Array<Menu>, menuItem){
    let div = this.renderer2.createElement('div');
    this.renderer2.addClass(div, 'card'); 
    this.renderer2.setAttribute(div, 'id', 'menu'+menuItem.id);
    let link = this.renderer2.createElement('a');
    this.renderer2.addClass(link, 'menu-item-link');
    this.renderer2.setAttribute(link, 'data-toggle', 'tooltip');
    this.renderer2.setAttribute(link, 'data-placement', 'right');
    this.renderer2.setAttribute(link, 'data-animation', 'false');
    this.renderer2.setAttribute(link, 'data-container', '.vertical-menu-tooltip-place');    
    this.renderer2.setAttribute(link, 'data-original-title', menuItem.title);
    let icon = this.renderer2.createElement('i');
    this.renderer2.addClass(icon, 'fa');
    this.renderer2.addClass(icon, 'fa-'+menuItem.icon);
    this.renderer2.appendChild(link, icon);
    let span = this.renderer2.createElement('span');
    this.renderer2.addClass(span, 'menu-title');
    this.renderer2.appendChild(link, span);
    let menuText = this.renderer2.createText(menuItem.title);
    this.renderer2.appendChild(span, menuText);
    this.renderer2.setAttribute(link, 'id', 'link'+menuItem.id);
    this.renderer2.addClass(link, 'transition');
    this.renderer2.appendChild(div, link);
    if(menuItem.routerLink){             
      this.renderer2.listen(link, "click", () => { 
          this.router.navigate([menuItem.routerLink]);
          this.setActiveLink(menu,link);
          this.closeOtherSubMenus(div);
      });
    }
    if(menuItem.href){
      this.renderer2.setAttribute(link, 'href', menuItem.href);
    }
    if(menuItem.target){
      this.renderer2.setAttribute(link, 'target', menuItem.target);
    }
    if(menuItem.hasSubMenu){
      this.renderer2.addClass(link, 'collapsed'); 
      let caret = this.renderer2.createElement('b');
      this.renderer2.addClass(caret, 'fa');
      this.renderer2.addClass(caret, 'fa-angle-up');
      this.renderer2.appendChild(link, caret);
      this.renderer2.setAttribute(link, 'data-toggle', 'collapse');      
      this.renderer2.setAttribute(link, 'href', '#collapse'+menuItem.id);
      let collapse = this.renderer2.createElement('div');
      this.renderer2.setAttribute(collapse, 'id', 'collapse'+menuItem.id);
      this.renderer2.setAttribute(collapse, 'data-parent', '#menu'+menuItem.parentId);
      this.renderer2.addClass(collapse, 'collapse');
      this.renderer2.appendChild(div, collapse);          
      this.createSubMenu(menu, menuItem.id, collapse, 'vertical');
    }
    return div;
  }

  public createHorizontalMenuItem(menu:Array<Menu>, menuItem){
      let li = this.renderer2.createElement('li');
      this.renderer2.addClass(li, 'menu-item');
      let link = this.renderer2.createElement('a');
      this.renderer2.addClass(link, 'menu-item-link');
      this.renderer2.setAttribute(link, 'data-toggle', 'tooltip');
      this.renderer2.setAttribute(link, 'data-placement', 'top');
      this.renderer2.setAttribute(link, 'data-animation', 'false');
      this.renderer2.setAttribute(link, 'data-container', '.horizontal-menu-tooltip-place');    
      this.renderer2.setAttribute(link, 'data-original-title', menuItem.title);
      let icon = this.renderer2.createElement('i');
      this.renderer2.addClass(icon, 'fa');
      this.renderer2.addClass(icon, 'fa-'+menuItem.icon);
      this.renderer2.appendChild(link, icon);
      let span = this.renderer2.createElement('span');
      this.renderer2.addClass(span, 'menu-title');
      this.renderer2.appendChild(link, span);
      let menuText = this.renderer2.createText(menuItem.title);
      this.renderer2.appendChild(span, menuText);
      this.renderer2.appendChild(li, link);
      this.renderer2.setAttribute(link, 'id', 'link'+menuItem.id);
      this.renderer2.addClass(link, 'transition');
      if(menuItem.routerLink){             
        this.renderer2.listen(link, "click", () => {  
            this.router.navigate([menuItem.routerLink]);
            this.setActiveLink(menu, link);
        });
      }
      if(menuItem.href){
        this.renderer2.setAttribute(link, 'href', menuItem.href);
      }
      if(menuItem.target){
        this.renderer2.setAttribute(link, 'target', menuItem.target);
      }
      if(menuItem.hasSubMenu){
        this.renderer2.addClass(li, 'menu-item-has-children');
        let subMenu = this.renderer2.createElement('ul');
        this.renderer2.addClass(subMenu, 'sub-menu');
        this.renderer2.appendChild(li, subMenu);
        this.createSubMenu(menu, menuItem.id, subMenu, 'horizontal');
      }
      return li;
  }

  private createSubMenu(menu:Array<Menu>, menuItemId, parentElement, type){
      let menus = menu.filter(item => item.parentId === menuItemId);
      menus.forEach((menuItem) => {
        let subMenu = null;
        if(type=='vertical'){
           subMenu = this.createVerticalMenuItem(menu, menuItem);
        }
        if(type=='horizontal'){
           subMenu = this.createHorizontalMenuItem(menu, menuItem);
        }      
        this.renderer2.appendChild(parentElement, subMenu);
      });
  } 

  private closeOtherSubMenus(elem){
      let children = (this.renderer2.parentNode(elem)).children;
      for (let i = 0; i < children.length; i++) {
          let child = this.renderer2.nextSibling(children[i].children[0]);
          if(child){
              this.renderer2.addClass(children[i].children[0], 'collapsed');   
              this.renderer2.removeClass(child, 'show');               
          }
      }
  }

  public getActiveLink(menu:Array<Menu>){
      let url = this.location.path();
      let routerLink = (url) ? url : '/';  // url.substring(1, url.length);
      let activeMenuItem = menu.filter(item => item.routerLink === routerLink);
      if(activeMenuItem[0]){
        let activeLink = document.querySelector("#link"+activeMenuItem[0].id);
        return activeLink;
      }
      return false;
  }

  public setActiveLink(menu:Array<Menu>, link){
      if(link){
          menu.forEach((menuItem) => {
            let activeLink = document.querySelector("#link"+menuItem.id);
            if(activeLink){
              if(activeLink.classList.contains('active-link')){
                activeLink.classList.remove('active-link');
              }
            }       
          });
          this.renderer2.addClass(link, 'active-link'); 
      }    
  } 

  public showActiveSubMenu(menu:Array<Menu>){
      let url = this.location.path();
      let routerLink = url; //url.substring(1, url.length);
      let activeMenuItem = menu.filter(item => item.routerLink === routerLink);
      if(activeMenuItem[0]){
          let activeLink = document.querySelector("#link"+activeMenuItem[0].id);      
          let parent = this.renderer2.parentNode(activeLink);
          while (this.renderer2.parentNode(parent)){         
              parent = this.renderer2.parentNode(parent);
              if(parent.className == 'collapse'){
                let parentMenu = menu.filter(item => item.id === activeMenuItem[0].parentId);           
                let activeParentLink = document.querySelector("#link"+parentMenu[0].id);
                this.renderer2.removeClass(activeParentLink, 'collapsed');
                this.renderer2.addClass(parent, 'show');                
              }
              if(parent.classList.contains('menu-wrapper')){
                break;
              }
          }
      }     
  }

  public addNewMenuItem(menu:Array<Menu>, newMenuItem, type){
      menu.push(newMenuItem);
      if(newMenuItem.parentId != 0){
        let parentMenu =  menu.filter(item => item.id === newMenuItem.parentId);
        if(parentMenu.length){
            if(!parentMenu[0].hasSubMenu){
              parentMenu[0].hasSubMenu = true;
            // parentMenu[0].routerLink = null;
          } 
        }                
      }
      let menu_wrapper = null;
      if(type=='vertical'){
        menu_wrapper = document.getElementById('vertical-menu');
      }
      if(type=='horizontal'){
        menu_wrapper = document.getElementById('horizontal-menu');
      }
      while (menu_wrapper.firstChild) {
          menu_wrapper.removeChild(menu_wrapper.firstChild);
      }      
      this.createMenu(menu, menu_wrapper, type);
  } 


  private _vertical_menu_items: any;
    
  public get vertical_menu_items(){
      return this._vertical_menu_items;
  }

  public set vertical_menu_items(menu_items){
      this._vertical_menu_items = menu_items;
  }

  public get horizontal_menu_items(){
      return this.vertical_menu_items;
  }

  public getMenuItems(){

    this.vertical_menu_items = [];
    
    let tms_components = this.localStorageService.get('components');

    //dashboard
    this._vertical_menu_items.push(new Menu (1, 'Dashboard', '/', null, 'tachometer', null, false, 0));
    
    if(tms_components){
      tms_components.forEach(component_item =>{
       
        switch(component_item){
            //case 'Dashboard': {this._vertical_menu_items.push(new Menu (1, 'Dashboard', '/', null, 'tachometer', null, false, 0));break;};

            //Jobs
            case 'Jobs': {
              var jsm = false;
              jsm = this.svc_component_settings.hasSubMenu('Jobs');
              this._vertical_menu_items.push(new Menu(2, 'Jobs', 'bookings/connotesv2', null, 'calendar-plus-o', null, jsm, 0));
              break;
            };

            case 'Create Booking': {this._vertical_menu_items.push(new Menu(21, 'Create Booking', 'bookings/add', null, 'plus', null, false, 2));break;};
            case 'Import CSV': {this._vertical_menu_items.push(new Menu(22, 'Import CSV', 'bookings/connotes/import', null, 'file-text', null, false, 2));break;};
            case 'Connotes': {this._vertical_menu_items.push(new Menu(23, 'Connotes', 'bookings/connotesv2', null, 'list-ul', null, false, 2));break;};
            case 'Local Dispatch': {this._vertical_menu_items.push(new Menu(24, 'Local Dispatch', 'dispatch/local-dispatch', null, 'map-pin', null, false, 2));break;};
            case 'Local Manifest': {this._vertical_menu_items.push(new Menu(27, 'Local Manifest', 'dispatch/local-manifest', null, 'list-ul', null, false, 2));break;};
            case 'Linehaul Dispatch': {this._vertical_menu_items.push(new Menu(25, 'Linehaul Dispatch', 'dispatch/dispatchplanner', null, 'map-signs', null, false, 2));break;};
            case 'Linehaul Manifest': {this._vertical_menu_items.push(new Menu(26, 'Linehaul Manifest', 'dispatch/manifestlist', null, 'list-ul', null, false, 2));break;};
            case 'Activities': {this._vertical_menu_items.push(new Menu(28, 'Activities', 'jobnotifications', null, 'navicon', null, false, 2));break;};
            ////

            //Drivers
            case 'Drivers': {
              var dsm = false;
              dsm = this.svc_component_settings.hasSubMenu('Drivers');
              this._vertical_menu_items.push(new Menu(3, 'Drivers', 'drivers/driverslist', null, 'drivers-license', null, dsm, 0));
              break;  
            };
            
            case 'Add Driver': {this._vertical_menu_items.push(new Menu(31, 'Add Driver', 'drivers/adddriver', null, 'user-circle', null, false, 3));break;};
            case 'Incidents': {this._vertical_menu_items.push(new Menu(32, 'Incidents', 'incidents', null, 'exclamation-triangle', null, false, 3));break;};
            ////

            //Fleet
            case 'Fleet': {
              var fsm = false;
              fsm = this.svc_component_settings.hasSubMenu('Fleet');
              this._vertical_menu_items.push(new Menu(4, 'Fleet', 'fleet/listfleets', null, 'truck', null, fsm, 0));
              break;
            };
            
            case 'Assets': {this._vertical_menu_items.push(new Menu(41, 'Assets', 'fleet/fleetassets', null, 'line-chart', null, false, 4));break;};
            case 'Maintenance': {this._vertical_menu_items.push(new Menu(42, 'Maintenance', 'fleet/maintenance', null, 'wrench', null, false, 4));break;};
            ////

            //Fuel
            case 'Fuel': {
              var fsm2 = false;
              fsm2 = this.svc_component_settings.hasSubMenu('Fuel');
              this._vertical_menu_items.push(new Menu(5, 'Fuel', 'fuel', null, 'tint', null, fsm2, 0));
              break;
            };
            
            case 'Fuel Cards': {this._vertical_menu_items.push(new Menu(51, 'Fuel Cards', 'fuel/fuel_cards', null, 'credit-card', null, false,5));break;};
            
            case 'Fuel Levy': {this._vertical_menu_items.push(new Menu(52, 'Fuel Levy', 'fuel/fuellevy', null, 'calculator', null, false,5));break;};
            ////

            //Accounts
            case 'Accounts': {
              var asm = false;
              asm = this.svc_component_settings.hasSubMenu('Accounts');
              if(asm){
                this._vertical_menu_items.push(new Menu(6, 'Accounts', null, null, 'users', null, true, 0));
              }
              break;
            };

            case 'Payrolls': {this._vertical_menu_items.push(new Menu(61, 'Payrolls', 'payrolls', null, 'money', null, false, 6));break;};
            case 'Invoices': {
              var ism = false;
              ism = this.svc_component_settings.hasSubMenu('Invoices');
              this._vertical_menu_items.push(new Menu(62, 'Invoices', 'invoices', null, 'calculator', null, ism, 6));
              break;
            };

            case 'Select': {this._vertical_menu_items.push(new Menu(621, 'Select', 'invoices/invoiceselect', null, 'mouse-pointer', null, false, 62));break;};
            case 'Bills': {this._vertical_menu_items.push(new Menu(63, 'Bills', 'bills', null, 'dollar', null, false, 6));break;};
            case 'Credit Notes': {this._vertical_menu_items.push(new Menu(64, 'Credit Notes', 'creditnotes', null, 'credit-card-alt', null, false, 6));break;};
            ////

            //Contacts
            case 'Contacts': {
              var csm = false;
              csm = this.svc_component_settings.hasSubMenu('Contacts');
              if(csm){
                this._vertical_menu_items.push(new Menu(7, 'Contacts', null, null, 'address-card', null, true, 0));
              }
              break;
            };

            case 'People Contacts': {this._vertical_menu_items.push(new Menu(71, 'People Contacts', 'peoplecontacts', null, 'street-view', null, false, 7));break;};
            case 'Customers': {this._vertical_menu_items.push(new Menu(72, 'Customers', 'customers/listcustomers', null, 'user', null, false, 7));break;};
            case 'Suppliers': {this._vertical_menu_items.push(new Menu(73, 'Suppliers', 'suppliers', null, 'user-circle-o', null, false, 7));break;};
            ////

            // Braches
            case 'Breaches': { 
              var bsm = false;
              bsm = this.svc_component_settings.hasSubMenu('Breaches');
              if(bsm){
                this._vertical_menu_items.push(new Menu(8, 'Breaches', null, null, 'hand-paper-o', null, true, 0));
              };
              break;
            };

            case 'Breach Requests': {this._vertical_menu_items.push(new Menu(81, 'Breach Requests', 'breaches/requests', null, 'comment-o', null, false, 8));break;};
            case 'Breach Responses': {this._vertical_menu_items.push(new Menu(82, 'Breach Responses', 'breaches/responses', null, 'comments-o', null, false, 8));break;};
            case 'Breach Settings': {this._vertical_menu_items.push(new Menu(83, 'Breach Settings', 'breaches/settings', null, 'sliders', null, false, 8));break;};
            ////

            //Map Tracker
            case 'Tracker': {this._vertical_menu_items.push(new Menu(9, 'Tracker', 'maptracker', null, 'map-marker', null, false, 0));break;};

            //Registrations
            case 'Registrations': {
              var regsm = false;
              regsm = this.svc_component_settings.hasSubMenu('Registrations');
              if(regsm){
                this._vertical_menu_items.push(new Menu(10, 'Registrations', null , null, 'file', null, true, 0));
              }
              break;
            };
            
            case 'Employee Registrations': {this._vertical_menu_items.push(new Menu(101, 'Employee Registrations', 'registrations/employee-registrations', null, 'user-circle-o', null, false, 10));break;};
            case 'Customer Registrations': {  this._vertical_menu_items.push(new Menu(102, 'Customer Registrations', 'registrations/customerregistrations', null, 'user-circle', null, false, 10));break;};
            
            //Settings
            case 'Settings': {
              var ssm = false;
              ssm = this.svc_component_settings.hasSubMenuSettings();
              this._vertical_menu_items.push(new Menu(11, 'Settings', 'settings/setting', null, 'cogs', null, ssm, 0));
              break;
            };

            case 'My Profile': {this._vertical_menu_items.push(new Menu (111, 'My Profile', 'profile', null, 'user', null, false, 11));break;};
            case 'Admin Accounts': {this._vertical_menu_items.push(new Menu(112, 'Admin Accounts', 'users', null, 'cogs', null, false, 11));break;};
            case 'Business Profile': {this._vertical_menu_items.push(new Menu(113, 'Business Profile', 'settings/businessprofile', null, 'building', null, false, 11));break;};
            case 'Employee Positions': {this._vertical_menu_items.push(new Menu(114, 'Employee Positions', 'settings/employee-positions', null, 'suitcase', null, false, 11));break;};
            case 'Checklists': {
              var chsm = false;
              chsm = this.svc_component_settings.hasSubMenu('Checklists');
              if(chsm){
                this._vertical_menu_items.push(new Menu(115, 'Checklists', null, null, 'list-alt', null, true, 11));
              }
              break;
            }; //'settings/checklists'
            case 'Driver': {this._vertical_menu_items.push(new Menu(1151, 'Driver', 'settings/checklists/driver', null, 'drivers-license', null, false, 115));break;};
            case 'Rigid Truck': {this._vertical_menu_items.push(new Menu(1152, 'Rigid Truck', 'settings/checklists/car', null, 'car', null, false, 115));break;};
            case 'Prime Mover': {this._vertical_menu_items.push(new Menu(1153, 'Prime Mover', 'settings/checklists/truck', null, 'truck', null, false, 115));break;};
            case 'Trailer': {this._vertical_menu_items.push(new Menu(1154, 'Trailer', 'settings/checklists/trailer', null, 'chevron-circle-right', null, false, 115));break;};
            case 'Forklift Truck': {this._vertical_menu_items.push(new Menu(1155, 'Forklift Truck', 'settings/checklists/forklift', null, 'code-fork', null, false, 115));break;};
            case 'Route Templates': {this._vertical_menu_items.push(new Menu(116, 'Route Templates', 'settings/routetemplates', null, 'road', null, false, 11));break;};
            case 'Costing & Invoice': {this._vertical_menu_items.push(new Menu(117, 'Costing & Invoice', 'settings/costing', null, 'calculator', null, false, 11));break;};
            case 'Payroll Setting': {this._vertical_menu_items.push(new Menu(118, 'Payroll Setting', 'settings/payrollsetting', null, 'money', null, false, 11));break;};
            case 'Job Cost Defaults': {this._vertical_menu_items.push(new Menu(119, 'Job Cost Defaults', 'settings/jobcostdefault', null, 'credit-card-alt', null, false, 11));break;};
            case 'Alert Rules': {this._vertical_menu_items.push(new Menu(1110, 'Alert Rules', 'settings/alertrules', null, 'exclamation-circle', null, false, 11));break;};
            case 'Fleet Service Interval': {this._vertical_menu_items.push(new Menu(1111, 'Fleet Service Interval', 'settings/fleetserviceinterval', null, 'server', null, false, 11));break;};
            case 'App Settings': {this._vertical_menu_items.push(new Menu(1112, 'App Settings', 'settings/constant', null, 'tablet', null, false, 11));break;};
            case 'Alert Templates': {this._vertical_menu_items.push(new Menu(1113, 'Alert Templates', 'settings/alerttemplates', null, 'tablet', null, false, 11));break;};
            case 'Weekly Inspection': {
              var wsm = false;
              wsm = this.svc_component_settings.hasSubMenu('Weekly Inspection');
              if(wsm){
                this._vertical_menu_items.push(new Menu(1114, 'Weekly Inspection', null, null, 'list-alt', null, true, 11));
              }
              break;
            };
            case 'Checklist': {this._vertical_menu_items.push(new Menu(11141, 'Checklist', 'settings/weekly-report/wr-checklist', null, 'list-alt', null, false, 1114));break;};
            case 'List': {this._vertical_menu_items.push(new Menu(11142, 'List', 'settings/weekly-report/wr-list', null, 'list-alt', null, false, 1114));break;};
            case 'Invoice Banks': {this._vertical_menu_items.push(new Menu(1115, 'Invoice Banks', 'settings/invoicebanks', null, 'bank', null, false, 11));break;};
            case 'Service Types': {this._vertical_menu_items.push(new Menu(1116, 'Service Types', 'settings/servicetypes', null, 'truck', null, false, 11));break;};
            case 'Corrective Action Report': {this._vertical_menu_items.push(new Menu(1117, 'Corrective Action Report', 'settings/correctiveaction', null, 'check-square-o', null, false, 11));break;};
            case 'Global Notifications': {this._vertical_menu_items.push(new Menu(1118, 'Global Notifications', 'settings/globalnotifications', null, 'bell-o', null, false, 11));break;};
            ////

            //Documents
            case 'Documents': {
              var docsm = false; 
              if(this.svc_component_settings.access_role_name == 'Compliance Administrator' || this.svc_component_settings.access_role_name == 'Super Administrator'){
                docsm = this.svc_component_settings.hasSubMenu('Documents');
              };              
              this._vertical_menu_items.push(new Menu(127, 'Documents', 'documents', null, 'files-o', null, docsm, 0));
              break;};

            case 'Compliance Admin Accounts': {
              if(this.svc_component_settings.access_role_name == 'Compliance Administrator' || this.svc_component_settings.access_role_name == 'Super Administrator'){
                this._vertical_menu_items.push(new Menu (1271, 'Compliance Admin Accounts', 'documents/complianceadminaccounts', null, 'user-o', null, false, 127));
              }
              break;};     
            
            case 'Induction Sets Configuration': {
                if(this.svc_component_settings.access_role_name == 'Compliance Administrator' || this.svc_component_settings.access_role_name == 'Super Administrator'){
                  this._vertical_menu_items.push(new Menu (1272, 'Induction Sets Configuration', 'documents/listinductionsets', null, 'wrench', null, false, 127));
                }
                break;};     
            ////

            //Tasks
            case 'Tasks': {this._vertical_menu_items.push(new Menu(128, 'Tasks', 'tasks', null, 'tasks', null, false, 0));break;};

            //Compliance
            case 'Compliance': {
              var csm2 = false;
              csm2 = this.svc_component_settings.hasSubMenu('Compliance');
              this._vertical_menu_items.push(new Menu(129, 'Compliance', 'compliance', null, 'check-square-o', null, csm2, 0));
              break;
            };

            case 'Lists': {this._vertical_menu_items.push(new Menu(1291, 'Lists', 'compliance/list', null, 'list-ul', null, false, 129));break;};
            ////

            //QAR
            case 'Quality Assurance Report': {this._vertical_menu_items.push(new Menu(124, 'Quality Assurance Report', 'qar', null, 'flag', null, false, 0));break;};

            //Messaging
            case 'Messaging': {this._vertical_menu_items.push(new Menu(130, 'Messaging', 'messaging', null, 'envelope-o', null, false, 0));break;};

            //Advanced Search 
            case 'Advanced Search': {this._vertical_menu_items.push(new Menu(131, 'Advanced Search', 'advanced', null, 'search', null, false, 0));break;};

            //Logicor Search
            case 'Logicor Website': {this._vertical_menu_items.push(new Menu (132, 'Logicor Website', null, 'http://logicor.net.au', 'external-link', '_blank', false, 0));break;};

            // Docu
            case 'Help': {this._vertical_menu_items.push(new Menu (133, 'Help', null, 'https://docs.developer.idrv.app/#section/Introduction', 'question-circle', '_blank', false, 0));break;};

        };
      });
    };
    
    if(this.svc_component_settings.access_role_name == 'Super Administrator'){
      this._vertical_menu_items.push(new Menu (134, 'Super Administrator', null, null, 'grav', null, true, 0));
      this._vertical_menu_items.push(new Menu (1341, 'Super Admin Accounts', 'superadmin/superadminaccounts', null, 'user-secret', null, false, 134));
      this._vertical_menu_items.push(new Menu (1342, 'TMS Components Settings', 'superadmin/componentssettings', null, 'cubes', null, false, 134));
    }

    this.vertical_menu_items = this._vertical_menu_items;
  }
}
 
